import React from "react";
import Footer from "../components/footer/Footer";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";
import {
  bannerList,
  companyCtaContentForPython,
  ctaSection,
  facts,
  faqData,
  hirePythonBitsclanContent,
  hirePythonChallengesData,
  hirePythonDeveloperSolution,
  hirePythonEngagementModels,
  hirePythonFaqSection,
  hirePythonPageContent,
  hirePythonTestimonialsData,
  mainBannerImg,
  servicesData,
  solutionsData,
  steps,
  tabItems,
  tabs,
  techCombinations,
} from "../data/hire-python-data";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import HirePageTestimonial from "../components/hire-page-testimonial/HirePageTestimonial";
import NewTeamSection from "../components/new-team-section/NewTeamSection";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import ChallengeSection from "../components/challenge-section/ChallengeSection";
import HirePageSolutionSection from "../components/hire-page-solution-section/HirePageSolutionSection";
import NewCtaSection from "../components/new-cta-section/NewCtaSection";

const HirePython = () => {
  const { t } = useTranslation("hirePythonPage");
  const bannerData = t("bannerContent", { returnObjects: true });
  const servicesData = t("servicesData", { returnObjects: true });
  const performanceData = t("developmentPerformaceData", {
    returnObjects: true,
  });
  const combinationSection = t("combinationData", { returnObjects: true });
  const stepsSection = t("stepsData", { returnObjects: true });
  const coverTheStackSection = t("coverTheStackData", { returnObjects: true });
  const factsSection = t("factsData", { returnObjects: true });
  const appIdeaData = t("appIdeaData", { returnObjects: true });
  const engagementModelData = t("engagementModelContent", {
    returnObjects: true,
  });
  const faqsSection = t("faqsSection", { returnObjects: true });
  const mainBannerImg = t("mainBannerImgData", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("hirePythonTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };
  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Hire Python Developers USA | Top Python Experts for Web, AI & Automation</title>
        <meta
          name="description"
          content="Hire the best Python developers in USA for web apps, automation, machine learning, and data solutions. Bitsclan offers vetted Python engineers for hire with fast and scalable project delivery. Get started with top Python talent today!"
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={bannerData?.shortHeading}
        mainHeading={bannerData?.mainHeading}
        description={bannerData?.content}
      />
      <TrustedPartner />

      <OurServices
        shortHeading={servicesData?.shortHeading}
        mainHeading={servicesData?.mainHeading}
        description={servicesData?.description}
        servicesCardsData={servicesData?.servicesData}
        buttonText={servicesData?.btnText}
      />

      <HirePageTestimonial
        shortHeading="Hear About Us from Our Clients"
        mainHeading="Trusted <span>Partnerships</span> Proven Python Excellence."
        description="Clients choose us not solely based on results but also for transparency, trustworthiness, & proactive partnership. Our Python professionals develop scalable solutions with clear communication & full ownership, working towards the long-term success of your business."
        testimonials={hirePythonTestimonialsData}
      />

      <NewTeamSection
        shortHeading="Our Team"
        mainHeading="Meet Our Expert Python Developers"
        description="Our dedicated Python engineers excel at building high-performing, scalable, and secure applications tailored to your business goals. From backend architecture and automation to AI-driven solutions and web platforms, our experts bring deep technical expertise and industry insight to every project—delivering reliable, future-ready software that drives growth and innovation."
      />

      <NewCtaSection content={ctaSection} />

      <NewCaseStudySection
        shortHeading="Our Clients’ Success Stories"
        heading="Driving <span>Business Transformation</span> with Python Excellence"
        description="Discover how our expert Python developers help global businesses innovate faster, scale smarter, and achieve measurable growth. From AI-powered platforms to robust enterprise applications, our Python solutions deliver real-world impact, transforming ideas into success stories across industries."
      />

      <WhyChooseUs
        shortHeading={performanceData?.shortHeading}
        greenHeading={performanceData?.greenHeading}
        heading={performanceData?.heading}
        content={performanceData?.description}
        stats={performanceData?.statsData}
      />



      {/* <DevelopmentPerformance
        heading={performanceData?.heading}
        greenHeading={performanceData?.greenHeading}
        subHeading={performanceData?.subHeading}
        solutions={performanceData?.solutions}
        buttonText={performanceData?.buttonText}
      /> */}

      <HireCombinationSection
        shortHeading="Best Python Combinations for Scalable Development"
        combinations={combinationSection?.combinations}
        heading={combinationSection?.heading}
        description={combinationSection?.description}
      />

      <WhyChooseBitsclan
        tabs={hirePythonBitsclanContent}
        expandAllAccordions={true}
        shortHeading="How We Work"
        heading="Why Top Businesses Choose Our Python Developers"
        subheading="Our Python experts combine technical excellence with business insight to deliver scalable, secure, and high-performance solutions. From rapid prototyping to enterprise-grade development, we follow an agile and transparent process that ensures efficiency, innovation, and on-time delivery. <br/> <br/> Partner with us to accelerate your digital transformation with powerful Python-driven applications that fuel growth and long-term success."
        ctaText="Hire Python Experts"
      />

      <SimpleModels content={hirePythonEngagementModels} />

      <HirePageSteps
        heading={stepsSection?.heading}
        subHeading={stepsSection?.subHeading}
        steps={stepsSection?.steps}
        buttonText={stepsSection?.buttonText}
      />

      <ChallengeSection
        mainHeading="Key Challenges in Python Development & Talent Hiring"
        description="Building and scaling Python teams comes with unique challenges — from finding skilled developers to ensuring performance, security, and scalability across projects."
        content={hirePythonChallengesData}
      />

      <HirePageSolutionSection
        shortHeading="Python Solutions We Deliver"
        mainHeading="How We Overcome Python Development Challenges"
        description="We simplify every stage of Python development — from hiring and onboarding to architecture, optimization, and deployment. Our experts ensure clean code, fast delivery, and scalable results, helping businesses turn complex ideas into reliable, high-performance Python applications that drive measurable growth."
        content={hirePythonDeveloperSolution}
      />

      <CoverTheStack
        shortHeading="Our Python Development Tech Stack"
        whereStart={coverTheStackSection?.whereStart}
        mainHeading={coverTheStackSection?.mainHeading}
        subHeading={coverTheStackSection?.subHeading}
        tabs={coverTheStackSection?.tabs}
        tabItems={coverTheStackSection?.tabItems}
      />

      <HireExpertFacts
        heading={factsSection?.heading}
        greenHeading={factsSection?.greenHeading}
        facts={factsSection?.facts}
        buttonText={factsSection?.buttonText}
        diffBannerBackgroundImage={mainBannerImg?.factBackgroundImage}
      />

      {/* <HirePageAppIdea
        heading={appIdeaData?.heading}
        content={appIdeaData?.content}
      /> */}

      {/* <HirePageEngagmentModels heading={engagementModelData?.headingContent} content={engagementModelData?.discription} hiringDetails={engagementModelData?.hiringDetails} buttonText={engagementModelData?.buttonText} /> */}

      {/* <SimpleModels content={engagementModelsContent} /> */}

      <TrendsInsights mainHeading="Thoughts from the World's Most Effective Python Development Team" description="Discover expert perspectives on Python development, detailed guidance that helps businesses improve customer experiences, enhance engagement, & create innovative, customer-focused digital solutions designed for sustainable growth & success." specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        faqs={hirePythonFaqSection?.faqData}
        specificClass="mobile-dev-page"
        mainHeading={hirePythonFaqSection?.mainHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={companyCtaContentForPython} />

      <Footer />
    </>
  );
};

export default HirePython;
